// NotificationDetailPage.js
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Avatar } from "antd";

import axios from "axios"; // Pour gérer les requêtes HTTP

const NotificationDetailPage = () => {
  const { id } = useParams(); // Récupérer l'ID de la notification depuis l'URL
  const [notification, setNotification] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getNotificationDetail = async () => {
      try {
        // Appeler l'API pour récupérer les détails de la notification
        const response = await axios.get(`/api/v1/notifications/${id}`);
        setNotification(response.data);
      } catch (err) {
        setError("Erreur lors de la récupération des détails de la notification.");
      } finally {
        setLoading(false);
      }
    };

    getNotificationDetail();
  }, [id]);

  if (loading) {
    return <div>Chargement...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  if (!notification) {
    return <div>Aucune donnée trouvée.</div>;
  }

  // Gérer les URL d'avatars et d'images pour le récepteur et l'émetteur
  const avatarImageRecep = notification?.receiver?.fileName;
  const imageUrlRecep = avatarImageRecep
    ? `${process.env.REACT_APP_API_MEDIA_URL}/print/${avatarImageRecep}`
    :'';
  const avatarImageEmet = notification?.emitter?.fileName;
  const imageUrlEmet = avatarImageEmet
    ? `${process.env.REACT_APP_API_MEDIA_URL}/print/${avatarImageEmet}`
    : '';
  const avatarImageVehRecp = notification?.receiver?.vehicle?.fileName;
  const imageUrlVehRecp = avatarImageVehRecp
    ? `${process.env.REACT_APP_API_MEDIA_URL}/print/${avatarImageVehRecp}`
    : '';
  const avatarImageVehEmet = notification?.emitter?.vehicle?.fileName;
  const imageUrlVehEmet = avatarImageVehEmet
    ? `${process.env.REACT_APP_API_MEDIA_URL}/print/${avatarImageVehEmet}`
    : '';

  return (
    <div>
      <h3>Détails de la notification</h3>
      <p><strong>Titre:</strong> {notification.title}</p>
      <p><strong>Message:</strong> {notification.message}</p>
      <p><strong>État:</strong> {notification.status}</p>
      <p><strong>Type:</strong> {notification.type}</p>
      <p><strong>Date:</strong> {new Date(notification.createdAt).toLocaleString()}</p>

      {/* Informations du récepteur */}
      {notification?.receiver && (
        <div>
          <div><strong>Informations du récepteur:</strong></div>
          <Avatar className="insp-small-avatarVehicle">
            <img src={imageUrlRecep} alt="" />
          </Avatar>
          <table>
            <tbody>
              <tr>
                <td>Nom</td>
                <td>Role</td>
                <td>Email</td>
                <td>Véhicule affecté</td>
              </tr>
              <tr>
                <td>{notification?.receiver?.name || "-"}</td>
                <td>{notification?.receiver?.role?.name || "-"}</td>
                <td>{notification?.receiver?.email || "-"}</td>
                <td>
                  <img src={imageUrlVehRecp} alt="" className="me-3 rounded-circle avatar-xs"/>
                  {notification?.receiver?.vehicle?.brand || "-"}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}

      {/* Informations de l'émetteur */}
      {notification?.emitter && (
        <div>
          <div><strong>Informations de l'émetteur:</strong></div>
          <Avatar className="insp-small-avatarVehicle">
            <img src={imageUrlEmet} alt="" />
          </Avatar>
          <table>
            <tbody>
              <tr>
                <td>Nom</td>
                <td>Role</td>
                <td>Email</td>
                <td>Véhicule affecté</td>
              </tr>
              <tr>
                <td>{notification?.emitter?.name || "-"}</td>
                <td>{notification?.emitter?.role?.name || "-"}</td>
                <td>{notification?.emitter?.email || "-"}</td>
                <td>
                  <img src={imageUrlVehEmet} alt="" className="me-3 rounded-circle avatar-xs"/>
                  {notification?.emitter?.vehicle?.brand || "-"}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default NotificationDetailPage;
